import axios from "axios";
import {useNavigate } from "react-router-dom";
import React from "react";


const AuthService = {
    login: async (userData) => {


        userData.expires_in_date = Date.now() + ((userData.expires_in - 10) * 1000);

        if (!userData.user.profile_image) {
            userData.user.profile_image = process.env.REACT_APP_URL_STORAGE + 'src/perfil_icone.png';
        }

        localStorage.setItem('users', JSON.stringify(userData));
    },
    logout: () => {
        localStorage.removeItem('users');
    },
    isAuthenticated: () => {
        const user = localStorage.getItem('users');
        if (!user) {
            return false;
        }
        try {
            const userData = JSON.parse(user);

            const expirationDate = new Date(userData.expires_in_date);
            const currentDate = new Date();

            if (expirationDate < currentDate) {
                localStorage.removeItem('users');
                return false;
            }
            return true;
        } catch (e) {
            return false;
        }
    },
    getUserData:  () => {
        try {

            const userData = localStorage.getItem("users");


            if (window.location.pathname === "/login" && !userData) {
                return null;
            }

            if (!userData) {
                // window.location.href = "/login";
                return null;
            }

            const parsedData = JSON.parse(userData);
            return parsedData?.user || null;
        } catch (error) {

            localStorage.removeItem("users");

            // if (window.location.pathname !== "/admin/login" && window.location.pathname !== "/admin/login/") {
            //     window.location.href = "/admin/login";
            // }

            return null;
        }
    },

    setPlan: (planId) => {

        const userData = localStorage.getItem('users');
        if (!userData) {
            return null;
        }

        // Acessa diretamente o objeto `data.user`
        const parsedData = JSON.parse(userData);
        parsedData.user.payment_plans_id = planId;
        localStorage.setItem('users', JSON.stringify(parsedData));
    },
    setUserValue: (subKey, value) => {
        const storedData = localStorage.getItem("users");
        if (!storedData) {
            return false;
        }

        // Converte para objeto
        const parsedData = JSON.parse(storedData);

        // Divide a chave e percorre os níveis do objeto
        let keys = subKey.split(".");
        let obj = parsedData.user; // Sempre modifica dentro de `data.user`

        for (let i = 0; i < keys.length - 1; i++) {
            if (!obj[keys[i]]) {
                obj[keys[i]] = {}; // Cria um objeto vazio se o caminho não existir
            }
            obj = obj[keys[i]];
        }

        obj[keys[keys.length - 1]] = value;

        // Salva de volta no localStorage
        parsedData.user = obj;
        localStorage.setItem("users", JSON.stringify(parsedData));

        return true; // Indica sucesso na atualização
    },
    getToken: () => {
        const userData = localStorage.getItem('users');
        return userData ? JSON.parse(userData).token : null;
    },
    getCompanyId: () => {
        const userData = localStorage.getItem("users");
        if (!userData) return null;

        const parsedData = JSON.parse(userData);

        if(parsedData.user?.companies?.length == 0){
            return userData.id;
        }
        const selectedCompany = parsedData.user?.companies?.find(c => c.selected === 1);

        if(!selectedCompany){
           if(parsedData.user?.companies) {
               return parsedData.user?.companies[0]?.user_id;
           }
           return parsedData.user.id;
        }

        return selectedCompany ? selectedCompany.user_id : null;
    },
    refreshToken: async () => {
        const {isRefreshing, setIsRefreshing, refreshSubscribers, addSubscriber, clearSubscribers} = useTokenRefresh();

        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                addSubscriber({resolve, reject});
            });
        }

        const userData = localStorage.getItem('users');
        if (!userData) {

            return false;
        }

        const data = JSON.parse(userData);

        const config = {
            headers: {
                'Authorization': `Bearer ${data.token}`,
                'Content-Type': 'application/json'
            }
        };

        setIsRefreshing(true);

        try {
            const response = await axios.post(process.env.REACT_APP_URL_API + 'refresh', {}, config);

            if (response.code === 200) {

                data.token = response.token;
                data.expires_in_date = Date.now() + ((response.expires_in - 30) * 1000);
                localStorage.setItem('users', JSON.stringify(data));

                refreshSubscribers.forEach(subscriber => subscriber.resolve(response.token));
                clearSubscribers();

                return true;
            } else {

                refreshSubscribers.forEach(subscriber => subscriber.reject(new Error('Falha ao atualizar o token')));
                clearSubscribers();
                return <Navigate  to="/admin/logout"/>;
            }
        } catch (error) {

            refreshSubscribers.forEach(subscriber => subscriber.reject(error));
            clearSubscribers();
            return <Navigate  to="/admin/logout"/>;
        } finally {
            setIsRefreshing(false);
        }
    },

    isTokenExpired: () => {
        const userData = localStorage.getItem('users');

        // Verificar se os dados do usuário estão presentes no localStorage
        if (!userData) {
            return true; // Caso não haja dados, considerar o token como expirado
        }

        try {
            const parsedData = JSON.parse(userData);

            // Verificar se a chave `expires_in_date` existe no objeto `data`
            if (parsedData  && parsedData.expires_in_date) {
                const expirationDate = new Date(parsedData.expires_in_date);
                const currentDate = new Date();

                return expirationDate < currentDate; // Retorna `true` se o token estiver expirado
            } else {
                return true; // Caso a chave `expires_in_date` não exista, considerar o token como expirado
            }
        } catch (error) {

            return true; // Em caso de erro, considerar o token como expirado
        }
    },


    updateData: (user) => {
        const userData = JSON.parse(localStorage.getItem('users'));
        Object.assign(userData.user, user);
        localStorage.setItem('users', JSON.stringify(userData));
    },

    updateImage: (imagem) => {
        const userData = JSON.parse(localStorage.getItem('users'));
        if (userData && userData.data.user) {
            userData.user.profile_image = imagem;
            localStorage.setItem('users', JSON.stringify(userData));
        } else {

        }
    }
};

export default AuthService;
